import React from 'react'
import { Helmet } from 'react-helmet'
import Footer from '../components/footer'
import projectsBG from '../assets/projectsbg.jpg'
import CProject1 from '../assets/projects/CProject1.jpg'
import CProject2 from '../assets/projects/CProject2.jpg'
import CProject3 from '../assets/projects/CProject3.jpg'
import CProject4 from '../assets/projects/CProject4.jpg'
import CProject5 from '../assets/projects/CProject5.jpg'
import CProject6 from '../assets/projects/CProject6.jpg'
import CProject7 from '../assets/projects/CProject7.jpg'
import CProject8 from '../assets/projects/CProject8.jpg'
import CProject9 from '../assets/projects/CProject9.jpg'
import CProject10 from '../assets/projects/CProject10.jpg'
import CProject11 from '../assets/projects/CProject11.jpg'
import CProject12 from '../assets/projects/CProject12.jpg'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCalendarAlt, faThumbtack, faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom'
import OnGoingProjects from '../components/onGoingProjects'
import OProject1 from '../assets/projects/OProject1.jpg'

class Projects extends React.Component{

    constructor(props){
        super(props);
        this.state = {
            projects: [
                {id: 1, image: CProject1, title: 'Sark One' , location: 'Mokilla, Shankarpally', date: '2013 - 15'},
                {id: 2, image: CProject2, title: 'Sark Two' , location: 'Mokilla, Shankarpally', date: '2014 - 16'},
                {id: 3, image: CProject3, title: 'Splendid Aparna' , location: 'Kompally', date: '2010 - 11'},
                {id: 4, image: CProject4, title: 'Manjeera - Diamond Towers' , location: 'Lingampally', date: '2011 - 12'},
                {id: 5, image: CProject5, title: 'Janapriya - Apartments' , location: 'Sainikpuri, ECIL', date: '2012 - 13'},
                {id: 6, image: CProject6, title: 'Janapriya - Villas' , location: 'Sainikpuri, ECIL', date: '2012 - 13'},
                {id: 7, image: CProject7, title: 'Aparna Grande' , location: 'Lingampally', date: '2013 - 14'},
                {id: 8, image: CProject8, title: 'Mahindhara' , location: 'Poonamallee, tandalam, Chennai', date: '2013 - 14'},
                {id: 9, image: CProject9, title: 'Thakkar Developers - EVA Luxuria' , location: 'Nasik, Maharashtra', date: '2013 - 14'},
                {id: 10, image: CProject10, title: 'Hemadurga Theatre' , location: 'Uppal, Hyderabad', date: '2014'},
                {id: 11, image: CProject11, title: 'Sark Heights' , location: 'Kondapur, Hyderabad', date: '2014 - 15'},
                {id: 12, image: CProject12, title: 'RGUKT - AP IIIT' , location: 'Indupayya, RK Valley', date: '2015 - 19'},
                {id: 13, image: OProject1, title: 'Lazuline Biotech Pvt Ltd' , location: 'Karkapatla', date: '2019-20'}
            ]
        }
    }

    render(){
        const bg = {
            backgroundImage: `url(${projectsBG})`,    
            backgroundSize: 'cover',
            backgroundPosition: 'center'
        }
        return(
            <div>
                <Helmet>
                    <title>Projects - The ongoing projects & finished projects we have delivered.</title>
                </Helmet>
                
                <section>
                    <div className="flex flex-col text-left md:px-10 px-2 py-10" style={bg}>
                       <h1 className="text-5xl uppercase text-white font-bold">Projects</h1>
                       <h1 className="text-2xl uppercase text-white">Innovation & Inspiration</h1>
                    </div>
                </section>

                <OnGoingProjects />

                <section className="md:px-10 px-2 bg-green-100 bg-opacity-75">
                    <div className="grid grid-cols-12 py-10 gap-6 ">
                        <div className="col-span-12">
                            <h2 className="text-xl text-green-700 bg-green-200 rounded-lg py-2 px-10 capitalize font-bold shadow"><FontAwesomeIcon icon={faCheckCircle} className="text-green-800 mr-2" />Completed Projects</h2>
                        </div>
                            {
                                this.state.projects.map(function (projects){
                                    return(
                                        <div className="col-span-12 md:col-span-3">
                                            <div className="card h-full border border-gray-400 hover:shadow-2xl overflow-hidden bg-white rounded-lg relative">
                                                <img src={projects.image} alt={projects.title}/>
                                                <div className="absolute top-0 right-0 w-12 h-12 flex items-center justify-center p-2 rounded-full bg-as font-bold text-2xl text-white m-5 border-2 border-white">{projects.id}</div>
                                                <div className="card-body p-5">
                                                    <p className="text-xl font-semibold tracking-tight">{projects.title}</p>
                                                    <div className="flex items-center justify-between mt-5">
                                                        <p className="text-base w-75"><FontAwesomeIcon className="mr-2  text-pink-600 "  icon={faThumbtack} />{projects.location}</p>
                                                        <p className="text-base"><FontAwesomeIcon  className="mr-2 text-pink-600 " icon={faCalendarAlt} />{projects.date}</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )
                                })
                            }
                        </div>
                </section>

                <section className="md:px-10 px-2 py-10">
                    <div className="grid grid-cols-12 gap-6">
                        <div className="col-span-12 md:col-span-6 md:col-start-4">
                            <div className="p-5 bg-ap rounded-lg">
                                <div className="flex flex-col md:flex-row items-center justify-center md:justify-between">
                                    <h3 className="text-2xl md:text-3xl text-white font-bold mb-5 md:mb-0">Request a free quote</h3>
                                    <Link to="/contact-us" className="bg-white px-5 py-3 font-bold text-base uppercase">Request free quote</Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                    
                <Footer />
            </div>
        )
    }
}

export default Projects;


// WEBPACK FOOTER //
// ./src/pages/projects.jsx